import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DTFHomepageService } from '../dtfhomepage/dtfhomepage.service';
import { AuthorizationService } from '../authorization/authorization.service';
import { WindowRef } from '../../utils/window';

import { TranslateService } from '@ngx-translate/core';
import { Banner } from '../../shared/models/banner';
import { TranslateUtil } from '../../utils/translate-util';
import { APP_CONSTANTS } from '../../utils/app-constants';
import { AccoutDetailsResponse } from '../../shared/models/accountDetailsResponse';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { SelectionModel } from '@angular/cdk/collections';
import { ContractNumberRequest } from '../../shared/models/contractNumberResponse';
import { MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { DcsAccountNumber } from '../../shared/models/dcsAccountNumber';

import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { SharedTranslateModule } from '../../utils/sharedTranslateModule';
import { MatButtonModule } from '@angular/material/button';
import { SessionTimeoutComponent } from '../sessionTimeout/sessionTimeout.component';
enum CheckeBill {
  Enroll_ebill,
  Terminate_ebill,
  NONE
};



export enum ToggleEnum { //used for mat toggle
  Option1,
  Option2,
  Option3,
  Option4,
  Option5,
  Option6
}

@Component({
    selector: 'div.dtf-docrequest',
    templateUrl: './docrequest.component.html',
    imports: [SharedTranslateModule,SessionTimeoutComponent,
        MatPaginator, MatSort, MatTableModule, MatCheckboxModule, MatFormFieldModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatIconModule, MatDatepickerModule, MatNativeDateModule, MatSortModule
    ],
    providers: [],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ]
})

export class DocRequestComponent implements OnInit {
  title = 'Content Section of the Page';
  router: Router;
  path = '';
  loginRedirect = '';
  accountRedirect = '';
  password2 = '';
  password3 = '';
  reTypePassword = '';
  token: string;
  brandId: string;
  action = '';
  loginAttempt = false;
  isLoginattempt = '';
  enrollFlagFromDB: string;
  countryFlag: string;
  langFlag: string;
  currentCountry: string;
  isCanadaPortal = false;
  baseUrl = '';
  currentPassword = '';
  emailAddress = '';
  thirdPartyNumber='';
  phoneNumber ='';
  name ='';
  fax ='';
  nameOfDMV ='';
  DMVAddress = '';
  DMVPhone = '';
  DMVStateCityZip ='';
  odometer = '';
  usUrl: string;
  caUrl: string;
  azURL: string;
  agentview: string;
  selectedRequest: string;
  agentId: string;
  bodyLoaded = false;
  dbLoaded = false;
  isFrench = false;
  openLoginModal = false;
  serviceErrorOccurred = false;
  serviceErrorDesc = '';
  error = '';
  userId = '';
  dbData: any;
  public alerts: Banner;
  toggleOpen: any;
  recAccCount = '';
  totalDue = '';
  language = '';
  ciamId = sessionStorage.getItem('loginID');
  contractCopyForm: FormGroup;
  SelectContractCopy = false;
  SelectTitleRelease = false;
  contract: ContractNumberRequest;
  accountDetailsRes: AccoutDetailsResponse[];
  contractNumberList: ContractNumberRequest[];
  dscAccountList : DcsAccountNumber[];
  dscAccount: DcsAccountNumber;
  contractSelected = false;
  disabledFlag =false;
  dataLoaded=true;
  tableLoaded = true;
  CANCEL = '';
  toggleEnum = ToggleEnum;
  selectedState = ToggleEnum.Option6;
  value = '';

  filterActive = false;
  filter = false;
  rowCount = 0;
  hasNumeric = false;
  
  phoneLength = false;
  phoneValid =false;
  showPhoneErrors = false;

    // Table columns
  // Table columns
  initColumns: any[] = [
    {
      name: 'select',
      display: '',
      displayMobile: '',
      displayFR: '',
      dispFormat: ''
    },
    {
      name: 'contractNum',
      display: 'Account',
      displayFR: 'Compte',
      dispFormat: 'contract'
    },
    {
      name: 'lastPayRcvd',
      display: 'Last Payment',
      displayFR: 'Dernier paiement reçu',
      dispFormat: 'currency'
    },
    {
      name: 'contractType',
      display: 'Account Type',
      displayFR: 'Type de compte',
      dispFormat: ''
    },
    {
      name: 'termDate',
      display: 'Maturity Date',
      displayFR: 'Date de maturité',
      dispFormat: 'date'
    },
    {
      name: 'totalDue',
      display: 'Current Due',
      displayFR: 'Solde actuel',
      dispFormat: 'currency'
    },
    {
      name: 'currentDt',
      display: 'Due Date',
      displayFR: 'Date d\'échéance',
      dispFormat: 'date'
    },
   {
      name: 'status',
      display: 'Status',
      displayFR: 'Statut',
      dispFormat: ''
    }
  ];
    displayedColumns: any[] = this.initColumns.map(col => col.name);
  
  
  dataSource: MatTableDataSource<AccoutDetailsResponse>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  selection = new SelectionModel<AccoutDetailsResponse>(true, []);


  constructor(router: Router, private dtfhomepageService: DTFHomepageService, private fb: FormBuilder, public auth: AuthorizationService,
    private _window: WindowRef, public translate: TranslateService, public translateUtil: TranslateUtil, public dialog: MatDialog

  ) {
    this.router = router;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
    this.accountDetailsRes =[];
    this.dataSource = new MatTableDataSource(this.accountDetailsRes);
    }

  ngAfterViewInit() {
  }


  onChangeButton($event) { //Used for mat-toggle conditions to filter DB
    this.selectedState = $event.value;
    this.disabledFlag = false;
    this.SelectContractCopy = false;
    this.SelectTitleRelease = false;
    if (this.selectedState === 0) {
      this.SelectContractCopy = true;
    }
    else if (this.selectedState === 1) {
      this.SelectTitleRelease = true;
    }
    this.getAccountDetailsListByUserId();
  }
  onURLChangeButton(num: number) { //Used for mat-toggle conditions to filter DB
    this.selectedState = num;
    this.SelectContractCopy = false;
    this.SelectTitleRelease = false;

    if (this.selectedState === 0) {
      this.SelectContractCopy = true; 
    }
    else if (this.selectedState === 1) {
      this.SelectTitleRelease = true;
    }
  }

  ngOnInit() {
    this.agentview = sessionStorage.getItem('agentview');
    this.agentId = sessionStorage.getItem('agentID');
    this.emailAddress = sessionStorage.getItem('emailAddress');
    this.thirdPartyNumber = sessionStorage.getItem('thirdPartyNumber');
 
    const openProfile = (window as any).mbfs.openProfile;
    if (openProfile === "ebill") {
      this.onURLChangeButton(3);
    }
    else if (openProfile === "autopay") {
      this.onURLChangeButton(2);
    }
    else{
      this.selectedRequest = sessionStorage.getItem('selectedRequest');
      if(this.selectedRequest === 'title state transfer'){
         this.selectedState = 1;
       }
       else{
         this.selectedState = 0;
       }
       sessionStorage.removeItem('selectedRequest');

      this.onURLChangeButton(this.selectedState);
    }
    const language = (window as any).mbfs.language;
    this.language= language;
    const country = (window as any).mbfs.country;
    this.countryFlag = country;
    this.langFlag = language;
    this.brandId = sessionStorage.getItem('brandId');
    this.token = sessionStorage.getItem('ciamToken');

    this.translateUtil.setCountryAndLangFromUIProp();
    this.translateUtil.getCurrentCountry().subscribe(val => {
      this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
      this.currentCountry = val;
    });
    this.isFrench = ('fr-CA' === language) ? true : false; //checks if language is french or english for Canada

    const dashBoardRequest = {
      ciamId: this.ciamId,
      ciamAZCode: this.token
    };
    this.getDashBoardDetails(dashBoardRequest);
    this.getAccountDetailsListByUserId();
    //  let element: HTMLElement = document.getElementById('auto_triggerc') as HTMLElement;
    // element.click();
    //this.getAlerts();
  }

  anouncementMgsopen(e: any) {
    e.preventDefault();
    if (this.toggleOpen) {
      this.toggleOpen = false;
    } else {
      this.toggleOpen = true;
    }
  }

  public inputValidator(event: any) {
    this.showPhoneErrors = true;
    let phonevalue = event.target.value;
    this.hasNumeric = /^\d+$/.test(phonevalue);
    this.phoneLength = (phonevalue.length === 10);
    this.phoneValid = this.phoneLength && this.hasNumeric;  
  }

  formValidationClasses = {
    'mbfs-error': true,
  };
  buildForm() {
    this.contractCopyForm = this.fb.group({
      emailAddress: [''],
      phoneNumber: [''],
      name: ['']
    });
  }

  getDashBoardDetails(dashBoardRequest) {
    this.auth.getDashBoardDetails(dashBoardRequest).subscribe(res => {
      this.recAccCount = res.recAccCount;
      this.totalDue = res.totalDue;
      if (this.totalDue.includes("-")) {
        this.totalDue = "0.00";
      }
    });
  }
  closeCIAMModal(e: Event) {
    this.openLoginModal = false;
    this.serviceErrorOccurred = false;
  }
  applyFilter(event: Event) {
    this.selectedState = undefined; //removes toggled mat-toggle
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    this.rowCount = this.dataSource.filteredData.length;
  }


  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSource.data.forEach(row => this.selection.select(row));
  }

  checkToggleSelected(){
    this.dscAccountList = [];
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    if(numSelected < 1){
      sessionStorage.setItem('addressdialog', 'error');
      this.translate.get('Errors.SelectOneAccount').subscribe((data:any)=> {
        this.error= data;
       });
      this.auth.SetErrorMessage(this.error);
      this.openDialog(5);
      this.contractSelected = false;
        }
    else{
      this.contractSelected = true;
    }
    for (var i = 0; i < this.selection.selected.length; i++) {
      this.dscAccount = new DcsAccountNumber();
      this.dscAccount.primaryCustomerAgreementNumber = this.selection.selected[i].contractNum.slice(0, -3);
      this.dscAccount.primaryCustomerScheduleNumber = "1";
      this.dscAccountList.push(this.dscAccount);
    }
   }

  getAccountDetailsListByUserId() {
    const accountDetailsRequest = {
      ciamId : this.ciamId ,
      ciamAZCode :this.token
    };
    this.auth.getAccountDetailsListByUserId(accountDetailsRequest).subscribe(res => {
        this.accountDetailsRes = res.accountdetailsList;
        this.dataSource = new MatTableDataSource(this.accountDetailsRes);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.dataSource.filterPredicate = function(data, filter: string): boolean {
          return data.contractNum.toLowerCase().includes(filter) || data.status.toLowerCase().includes(filter) || data.contractType.toLowerCase().includes(filter);
        };
        setTimeout(()=>{
          this.dbLoaded = true;
          this.filter = true;
          this.rowCount = this.dataSource.filteredData.length;
     });
    });
  }

  docRequest(event: Event) {
    this.checkToggleSelected();
    if(this.SelectContractCopy){
      if(this.contractSelected){
      if(!this.name){
        sessionStorage.setItem('addressdialog', 'error');
        this.translate.get('Errors.NameIsMissing').subscribe((data:any)=> {
          this.error= data;
         });
        this.auth.SetErrorMessage(this.error);
        this.openDialog(5);
      }
      else if(!this.phoneNumber){
        sessionStorage.setItem('addressdialog', 'error');
        this.translate.get('Errors.PhoneIsMissing').subscribe((data:any)=> {
          this.error= data;
         });
        this.auth.SetErrorMessage(this.error);
        this.openDialog(5);
      }
      // else if(!this.emailAddress){
      //   sessionStorage.setItem('addressdialog', 'error');
      //   this.auth.SetErrorMessage('Email is Missing');
      //   this.openDialog(5);
      // }
      else{
      this.disabledFlag = true;
      let docRequestFormRequest;
      if (this.language === 'en-CA' || this.language === 'fr-CA') {
         docRequestFormRequest = {
          ciamId: this.ciamId,
          ciamAZCode: this.token,
          emailAddress: this.emailAddress,
          firstName: this.name,
          phoneNumber: this.phoneNumber,
          myDoc:"contract copy",
          dcsAccountNumber: this.dscAccountList,
          country: this.currentCountry,
          language : this.language
        };
      }else{
         docRequestFormRequest = {
          ciamId: this.thirdPartyNumber,
          ciamAZCode: this.token,
          emailAddress: this.emailAddress,
          firstName: this.name,
          phoneNumber: this.phoneNumber,
          myDoc:"contract copy",
          dcsAccountNumber: this.dscAccountList,
          country: this.currentCountry,
          language : this.language
        };
      }

     
    
      this.auth.contractAndtitleStateTransfer(docRequestFormRequest).subscribe(res => {
        if (res.statusMessage === 'SUCCESS') {
          this.openDialog(1);
        }
        else {
          sessionStorage.setItem('addressdialog', 'error');
          this.translate.get('Errors.ErrorHasOccurred').subscribe((data:any)=> {
            this.error= data;
           });
          this.auth.SetErrorMessage(this.error);
          this.openDialog(5);
          // If checks to load BE error messages based on language
          if (this.language === 'en-CA') {
            this.serviceErrorDesc = res.status.message.shortMessage_EN;
          } else if (this.language === 'fr-CA') {
            this.serviceErrorDesc = res.status.message.shortMessage_FR;
          } else {
            this.serviceErrorDesc = res.status.message.shortMessage;
          }
          this.serviceErrorOccurred = true;
          setTimeout(() => {
            this.serviceErrorOccurred = false;
          }, 7000);  //2s
          this.disabledFlag = false;
        }
        this.dataLoaded=true;
      });
    }
      }
      else{
      this.disabledFlag = false;
      }
    }
   else if(this.SelectTitleRelease){
      if(this.contractSelected){
      if(this.isCanadaPortal){
        if(!this.name){
          sessionStorage.setItem('addressdialog', 'error');
          this.translate.get('Errors.NameIsMissing').subscribe((data:any)=> {
            this.error= data;
           });
          this.auth.SetErrorMessage(this.error);
          this.openDialog(5);
        }
        else if(!this.phoneNumber){
          sessionStorage.setItem('addressdialog', 'error');
          this.translate.get('Errors.PhoneIsMissing').subscribe((data:any)=> {
            this.error= data;
           });
          this.auth.SetErrorMessage(this.error);
          this.openDialog(5);
        }
        else{
          this.disabledFlag = true;
          const docRequestFormRequest = {
            ciamId: this.ciamId,
            ciamAZCode: this.token,
            emailAddress: this.emailAddress,
            firstName: this.name,
            phone: this.phoneNumber,
            myDoc:"title state transfer",
            dcsAccountNumber: this.dscAccountList,
            country: this.currentCountry,
            language : this.language
          };
        
          this.auth.contractAndtitleStateTransfer(docRequestFormRequest).subscribe(res => {
            if (res.statusMessage === 'SUCCESS') {
              this.openDialog(2);
            }
            else {
              sessionStorage.setItem('addressdialog', 'error');
              this.translate.get('Errors.ErrorHasOccurred').subscribe((data:any)=> {
                this.error= data;
               });
              this.auth.SetErrorMessage(this.error);
              this.openDialog(5);
              // If checks to load BE error messages based on language
              if (this.language === 'en-CA') {
                this.serviceErrorDesc = res.status.message.shortMessage_EN;
              } else if (this.language === 'fr-CA') {
                this.serviceErrorDesc = res.status.message.shortMessage_FR;
              } else {
                this.serviceErrorDesc = res.status.message.shortMessage;
              }
              this.serviceErrorOccurred = true;
              setTimeout(() => {
                this.serviceErrorOccurred = false;
              }, 7000);  //2s
              this.disabledFlag = false;
            }
            this.dataLoaded=true;
          });
        }
      }
      if(!this.isCanadaPortal){
      if(!this.name){
        sessionStorage.setItem('addressdialog', 'error');
        this.translate.get('Errors.NameIsMissing').subscribe((data:any)=> {
          this.error= data;
         });
        this.auth.SetErrorMessage(this.error);
        this.openDialog(5);
      }
      else if(!this.phoneNumber){
        sessionStorage.setItem('addressdialog', 'error');
        this.translate.get('Errors.PhoneIsMissing').subscribe((data:any)=> {
          this.error= data;
         });
        this.openDialog(5);
      }
      // else if(!this.emailAddress){
      //   sessionStorage.setItem('addressdialog', 'error');
      //   this.auth.SetErrorMessage('Email is Missing');
      //   this.openDialog(5);
      // }
      else if(!this.fax){
        sessionStorage.setItem('addressdialog', 'error');
        this.auth.SetErrorMessage('Fax is Missing');
        this.openDialog(5);
      }
      else if(!this.nameOfDMV){
        sessionStorage.setItem('addressdialog', 'error');
        this.auth.SetErrorMessage('Name of DMV/Title is Missing');
        this.openDialog(5);
      }
      else if(!this.DMVAddress){
        sessionStorage.setItem('addressdialog', 'error');
        this.auth.SetErrorMessage('DMV Street Address is Missing');
        this.openDialog(5);
      }
      else if(!this.DMVPhone){
        sessionStorage.setItem('addressdialog', 'error');
        this.auth.SetErrorMessage('DMV Phone Number is Missing');
        this.openDialog(5);
      }
      else if(!this.DMVStateCityZip){
        sessionStorage.setItem('addressdialog', 'error');
        this.auth.SetErrorMessage('DMV State, City, Zip is Missing');
        this.openDialog(5);
      }
      else if(!this.odometer){
        sessionStorage.setItem('addressdialog', 'error');
        this.auth.SetErrorMessage('Odometer is Missing');
        this.openDialog(5);
      }

      else{
      this.disabledFlag = true;
      const docRequestFormRequest = {
        ciamId: this.ciamId,
        ciamAZCode: this.token,
        emailAddress: this.emailAddress,
        firstName: this.name,
        phone: this.phoneNumber,
        myDoc:"title state transfer",
        dcsAccountNumber: this.dscAccountList,
        fax: this.fax,
        dmvPhysicalStreetAddress: this.DMVAddress,
        dmvCityStateZip: this.DMVStateCityZip,
        odometer: this.odometer,
        title: this.nameOfDMV,
        dmvphone: this.DMVPhone,
        country: this.currentCountry,
        language : this.language
      };
    
      this.auth.contractAndtitleStateTransfer(docRequestFormRequest).subscribe(res => {
        if (res.statusMessage === 'SUCCESS') {
          this.openDialog(2);
        }
        else {
          sessionStorage.setItem('addressdialog', 'error');
          this.translate.get('Errors.ErrorHasOccurred').subscribe((data:any)=> {
            this.error= data;
           });
          this.auth.SetErrorMessage(this.error);
          this.openDialog(5);
          // If checks to load BE error messages based on language
          if (this.language === 'en-CA') {
            this.serviceErrorDesc = res.status.message.shortMessage_EN;
          } else if (this.language === 'fr-CA') {
            this.serviceErrorDesc = res.status.message.shortMessage_FR;
          } else {
            this.serviceErrorDesc = res.status.message.shortMessage;
          }
          this.serviceErrorOccurred = true;
          setTimeout(() => {
            this.serviceErrorOccurred = false;
          }, 7000);  //2s
          this.disabledFlag = false;
        }
        this.dataLoaded=true;
      });
    }
      }
      }
      else{
      this.disabledFlag = false;
      }
    }
  }


  openDialog(num:any): void {
    if(num===1){
      sessionStorage.setItem('addressdialog', 'one');
    }
    if(num===2){
      sessionStorage.setItem('addressdialog', 'two');
    }
    if(num===5){
      sessionStorage.setItem('addressdialog', 'error');
    }
  let dialogRef = this.dialog.open(DocRequestDialogComponent, {
    maxWidth: '200vw',
    width: '500px',
  });
}
}



@Component({
    selector: 'dialog-docRequestDialogPopup',
    imports: [MatButtonModule,MatDialogContent, MatDialogActions,
        MatDialogClose],
    templateUrl: 'docRequestDialog.component.html'
})
export class DocRequestDialogComponent {
  usUrl: string;
  caUrl: string;
  addressdialog: string;
  language: string;
  errorMessage: string;
  contractNumberList: ContractNumberRequest[];

  constructor(router: Router, private dtfhomepageService: DTFHomepageService, private fb: FormBuilder, public auth: AuthorizationService,
    private _window: WindowRef, public translate: TranslateService, public translateUtil: TranslateUtil, public dialog: MatDialog

  ) {
    this.contractNumberList = [];
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
    this.addressdialog = sessionStorage.getItem('addressdialog');
    this.language = sessionStorage.getItem('language');
    this.auth.cast2.subscribe((results:any)=> {
      this.contractNumberList = results;
     });
     this.auth.cast3.subscribe((errorMessage:any)=> {
      this.errorMessage = errorMessage;
     });
  }

dashboardRedirect(e: Event) {
    let redirect = '';
    this.translate.get('LoginModal.AutoPayRedirect').subscribe((data:any)=> {
      redirect= this.usUrl +  data;
     });
     window.location.href = redirect;
  }
}

